import { AxiosInstance } from 'axios'

export enum UserInteractionType {
  ARTICLE_CLICKED = 'ARTICLE_CLICKED',
  AUDIO_COMPLETED = 'AUDIO_COMPLETED',
  COURSE_COMPLETED = 'COURSE_COMPLETED',
}

export type UserInteractionRequest = {
  id: string
  interaction_type: UserInteractionType
  interaction_date: string
}

export const postUserInteraction = (httpClient: Pick<AxiosInstance, 'post'>, request: UserInteractionRequest) =>
  httpClient.post('/v1/user-interactions', request)
